import { DeleteConfirmationModal } from 'components/core-ui/DeleteConfirmationModal'

export const DeleteModal = ({ isModalOpen, closeModal, itemId, setShouldRefreshData }) => (
    <DeleteConfirmationModal
        isModalOpen={isModalOpen}
        actionUrl='/iam/external-partners/managers/:id'
        content='Are you sure you want to deactivate this manager? This action cannot be undone.'
        closeModal={closeModal}
        itemId={itemId}
        setShouldRefreshData={setShouldRefreshData}
        succesMessage='Manager deactivated successfully'
        errorMessage='Failed to deactivate manager.'
    />
)